export const MOBILE = 576;
export const TABLET = 768;
export const DESKTOP = 1200;
